import "./index.css";
import "./i18n";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App.tsx";
import { StrictMode } from "react";
import { ThemeProvider } from "@/components/theme-provider.tsx";
import { createRoot } from "react-dom/client";
import { initSentry } from "@/lib/sentry";

initSentry();

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
